export enum CurrencyTimezone {
    "MYR" = "+0800",
    "SGD" = "+0800",
    "THB" = "+0700",
    "IDR" = "+0700"
}
